export default __webpack_public_path__ + "static/media/parachute-logo.d2f763e5.svg";